import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import MotionDiv from "../motionDiv";
import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

function ForumBlock() {

    return (
            <section id="forum" className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <Row>
                        <Col lg={5} md={5} sm={12}>
                            <MotionDiv>
                                <figure className="section-picture">
                                    <img src="/images/homepage/groupe_office.webp"
                                         alt="discussions"
                                         className="group office"
                                         width={592} height={791}
                                    />
                                </figure>
                            </MotionDiv>
                        </Col>

                        <Col lg={7} md={7} sm={12}>
                            <MotionDiv delay={0.5}>
                                <div className="sec-title">
                                    <h2>
                                        <span>Forums</span> Talents Handicap
                                    </h2>
                                    <h3>Recrutement et marque employeur - 100% en ligne
                                        <br/>
                                        Un espace d'écoute et d’échange avec nos experts
                                    </h3>
                                </div>
                            </MotionDiv>
                            <MotionDiv delay={0.8}>
                                <div className="text mt-30">
                                    <p>
                                        Chaque année, nous organisons <span>5 forums emploi handicap 100% digitaux</span>
                                        pour pouvoir y participer de n’importe où, sans se déplacer.
                                        <br/>
                                        <br/>
                                        Nos forums sont <span>la solution qualitative et personnalisée</span>
                                        pour recruter des talents en situation de handicap tout en valorisant sa marque employeur inclusive et handi-engagée.
                                        <br/>
                                        <br/>
                                        Plus qu’un événement, chaque forum est une <span>véritable campagne de recrutement</span>
                                        ouverte à tous les métiers et à tous les types de contrats (CDI, CDD, Alternance, Stage, intérim),
                                        faisant le focus sur une thématique essentielle (Alternance, IT,  Relation client…).
                                        <br/>
                                        <br/>
                                        <b>Un forum spécial SEEPH :</b>
                                        <br/>
                                        Organisé à l’occasion de <span>la semaine pour l’emploi des personnes handicapées (SEEPH)</span>,
                                        c’est le rendez-vous annuel qui vous permet en plus de dynamiser votre politique handicap et de bénéficier
                                        d’un kit complet pour vos communications interne et externe, et la sensibilisation de vos acteurs.
                                        <br/>
                                        <br/>
                                        <b>Le pack illimité annuel :</b>
                                        <br/>
                                        En complément des forums, c’est <span>la solution pour recruter toute l’année</span> :
                                        Cvthèque, mutlidiffusion de vos offres, valorisation de votre espace employeur...
                                    </p>
                                    <div className={'d-flex justify-content-center justify-content-sm-start'}>
                                        <Link to="https://www.talents-handicap.com/"
                                              target="_blank"
                                              className="theme-btn btn-style-one mt-3 mb-3 small">
                                            Plus d'infos sur nos forums et services associés
                                        </Link>
                                    </div>
                                </div>
                            </MotionDiv>
                        </Col>
                    </Row>
                </div>
            </section>
    );
}

export default ForumBlock;
